import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";


export interface Parent {
  title: string;
  name: string;
  namingId: string;
  level: number;
}

@Injectable({
  providedIn: 'root'
})
export class ResourceTreeService {

  parentSubject = new BehaviorSubject<Parent[]>([]);

  private parents: Parent[] = [];

  constructor() { }

  sendParent(parent: Parent): void {
    this.parents.push(parent);
    localStorage.setItem('resourceTree', JSON.stringify(this.parents));
    this.parentSubject.next(this.parents);
  }

  removeParents(parent: Parent): void {
    if (this.parents.length === parent.level && parent.level > 1) { // for resources with same level: splitter and ctoPort
      this.parents.pop();
    } else {
      for (let i = this.parents.length; i > parent.level; i--) {
        this.parents.pop();
      }
    }
    localStorage.setItem('resourceTree', JSON.stringify(this.parents));
    this.parentSubject.next(this.parents);
  }

  clearParents(): void {
    this.parents = [];
    localStorage.removeItem('resourceTree');
    this.parentSubject.next(this.parents);
  }

  getParents(): Parent[] {
    if (this.parents.length === 0) {
      this.parents = JSON.parse(localStorage.getItem('resourceTree'));
    }
    return this.parents;
  }

}
